/* CONFIG

Configure data used for graphic
*/

// JOIN
// Connect INPUT_FILE_PATH and map data using the following keys
export const LEFT_JOIN_KEY = "key"
export const RIGHT_JOIN_KEY = "state"

// ---------------------------------------------------------------------

// OTHER SETTINGS
// Max and min number of pixels that map can expand to
export const MAP_MAX_WIDTH = 650
export const MAP_MIN_WIDTH = 300
